import * as React from "react";
import { Component } from "react";
import "./PinModal.css";
import Modal from "../components/Modal/Modal";
import { PinForm } from './Form/PinForm';
// import { ExpansionPanel } from './ExpansionPanel';
// import { CheckBoxComponent } from './CheckBox';
import { IPinModel } from '../models/IPinModel';
import { IdentityService } from '../services/IdentityService';
import { ShowStatusBar } from '../components/Layout/GlobalStatusBar';
interface IProps {
    OnConfirmClick?: () => void;
    OnAbortClick: () => void;
}

interface IState {
    InputsVisible: boolean;
    Pin: string;
    PinConfirm: string;
    Finezjo: boolean;
    PF: boolean;
    ZF: boolean;
}

export class PinModal extends Component<IProps, IState> {
    private didSubmit = false;

    constructor(props) {
        super(props);

        this.state = {
            InputsVisible: false,
            Pin: "",
            PinConfirm: "",
            Finezjo: true,
            PF: false,
            ZF: false,
        }
    }

    public render() {
        return (
            <Modal
                onCloseClick={this.OnAbortClick}
            >
                <div className="pin-modal">
                    <div
                        onClick={this.OnAbortClick}
                        className="close-button" />
                    {this.state.InputsVisible ?
                        <div className="pin-inputs-wrapper">
                            <div className="pin-modal__title">
                                Dodaj kod PIN
                            </div>
                            <div className="pin-modal__inputs">
                                <PinForm
                                    Label="Twój kod pin"
                                    OnPinChange={this.OnPinChange}
                                    ValidationState={this.GetPinValidationState}
                                    ErrorBlock="Pin musi mieć 4 cyfry!"
                                />
                                <PinForm
                                    Label="Powtórz kod pin"
                                    OnPinChange={this.OnPinConfirmChange}
                                    ValidationState={this.GetPinConfirmValidationState}
                                    ErrorBlock="Pin musi być taki sam!"
                                />
                                {/* <ExpansionPanel
                                    Header={
                                        <div className="pin-checkbox__header">
                                            <div className="pin-checkbox__header-wrapper">
                                                <p className="pin-checkbox__title">Używaj PIN w serwisach</p>
                                                <p className="pin-checkbox__sub-title">Finezjo (domyślnie)</p>
                                            </div>

                                            <div className="button button--empty">
                                                <p>Edytuj</p>
                                            </div>
                                        </div>
                                    }
                                    ExpandedHeader={
                                        <div className="pin-checkbox__header pin-checkbox__header--flat">
                                            <div className="pin-checkbox__header-wrapper">
                                                <p className="pin-checkbox__title">Używaj PIN w serwisach</p>
                                            </div>
                                        </div>
                                    }
                                    ExpansionPanelClass="pin-checkbox-wrapper"
                                >
                                    <div className="pin-checkbox-container">
                                        <CheckBoxComponent
                                            Checked={this.state.Finezjo}
                                            Label={
                                                <span className="agreements">
                                                    Finezjo
                                                        </span>
                                            }
                                            OnClick={this.OnCheckboxToggle.bind(this, "Finezjo")}
                                            ClassNames="checkbox"
                                            LabelClassNames="checkbox__label"
                                        />
                                        <CheckBoxComponent
                                            Checked={this.state.ZF}
                                            Label={
                                                <span className="agreements">
                                                    Znajdź fizjoterapeutę
                                                        </span>
                                            }
                                            OnClick={this.OnCheckboxToggle.bind(this, "ZF")}
                                            ClassNames="checkbox"
                                            LabelClassNames="checkbox__label"
                                        />
                                        <CheckBoxComponent
                                            Checked={this.state.PF}
                                            Label={
                                                <span className="agreements">
                                                    Portal fizjoterapeuty
                                                        </span>
                                            }
                                            OnClick={this.OnCheckboxToggle.bind(this, "PF")}
                                            ClassNames="checkbox"
                                            LabelClassNames="checkbox__label"
                                        />
                                    </div>
                                </ExpansionPanel> */}
                            </div>
                            <div className="pin-modal__buttons">
                                <div
                                    onClick={this.OnAbortClick}
                                    className=" pin-modal__button pin-modal__button--empty">
                                    <p>Anuluj</p>
                                </div>
                                <div
                                    onClick={this.OnPinConfirm}
                                    className="pin-modal__button">
                                    <p>Dodaj PIN</p>
                                </div>
                            </div>
                        </div>
                        :
                        <>
                            <div className="pin-modal__image" />
                            <div className="pin-modal__title">
                                Dodaj PIN - zabezpiecz swoją dokumentację!
                            </div>
                            <div className="pin-modal__description">
                                Wprowadziliśmy nową funkcjonalność, która poprawi bezpieczeństwo Twoich pacjentów oraz poprawi wygodę korzystania z Finezjo.
                                Gdy odejdziesz od ekranu - zablokujemy go Twoim kodem PIN!
                            </div>
                            <div
                                onClick={this.OnConfirmClick}
                                className="pin-modal__button">
                                <p>Dodaj PIN</p>
                            </div>
                        </>
                    }
                </div>
            </Modal>
        );
    }

    private OnAbortClick = (evt) => {
        evt.stopPropagation();
        this.props.OnAbortClick();
    }

    private OnPinConfirm = (evt) => {
        evt.stopPropagation();
        this.didSubmit = true;
        if (this.GetPinValidationState() === 'success' && this.GetPinConfirmValidationState() === "success") {
            let identity = new IdentityService();
            let model: IPinModel = {
                pin: this.state.Pin,
                confirmpin: this.state.PinConfirm,
                forFinezjo: this.state.Finezjo,
                forPortal: this.state.PF,
                forZF: this.state.ZF
            };
            identity.SetPin(model, this.OnChangePinSuccess, this.OnChangePinError);
        } else {
            ShowStatusBar("Info", "Sprawdź poprawność formularza");
        }
        this.setState({});
    }

    private OnChangePinSuccess = (res) => {
        ShowStatusBar("Success", "Pin nadany");
        this.props.OnAbortClick();
    }

    private OnChangePinError = (err) => {
        ShowStatusBar("Error", "Nie udało się nadać pinu");
    }

    private OnConfirmClick = (evt) => {
        evt.stopPropagation();
        this.setState({
            InputsVisible: true
        })
    }

    private OnPinChange = (pin) => {
        this.setState({
            Pin: pin
        })
    }

    private OnPinConfirmChange = (pin) => {
        this.setState({
            PinConfirm: pin
        })
    }

    private GetPinValidationState = (): 'success' | 'warning' | 'error' | undefined => {
        const { Pin } = this.state;
        if (this.didSubmit === false) {
            return undefined;
        }

        if (Pin) {
            if (Pin.replace(" ", "").length === 4) {
                return "success";
            }
            return "error";
        }
        return "error";
    }

    private GetPinConfirmValidationState = (): 'success' | 'warning' | 'error' | undefined => {
        const { Pin, PinConfirm } = this.state;
        if (this.didSubmit === false) {
            return undefined;
        }
        if (Pin) {
            if (Pin === PinConfirm) {
                return "success";
            }
            return "error"
        }
        return "error"
    }

    // private OnCheckboxToggle = (item, event) => {
    //     let partialState = {};
    //     partialState[item] = !this.state[item];
    //     this.setState({
    //         ...partialState
    //     })
    // }
}



// WEBPACK FOOTER //
// ./src/controls/PinModal.tsx